// extracted by mini-css-extract-plugin
export default {"label":"LabeledInput_label__c561d","inlineLabel":"LabeledInput_inlineLabel__lZXSO","select":"LabeledInput_select__enT4a"};